<div class="recent-chats-root flex flex-col min-h-0 flex-1 pl-12 pr-0">
  <p-confirmDialog [key]="recentChatDeleteConfirmKey" [style]="{ width: '28rem' }">
    <ng-template pTemplate="message">
      <div class="recent-chat-delete-confirm">
        <p class="recent-chat-delete-confirm__main m-0">
          Are you sure you want to delete <b>"{{ deleteConfirmChatTitle }}"</b>?
        </p>
        <p class="recent-chat-delete-confirm__sub m-0">
          Once deleted, this item cannot be recovered.
        </p>
      </div>
    </ng-template>
  </p-confirmDialog>

  @if (network.isOnline() && state.conversationsLoading()) {
    <p class="px-10 py-8 text-[11px] text-[var(--p-slate-500)]">Loading…</p>
  }
  @if (network.isOnline() && state.conversationsError()) {
    <p class="px-10 py-8 text-[11px] text-[var(--p-red-600)]">{{ state.conversationsError() }}</p>
  }
  @if (actionError) {
    <p class="px-10 py-6 text-[11px] text-[var(--p-red-600)]">{{ actionError }}</p>
  }

  <div
    #scrollHost
    class="recent-chats-scroll flex-1 min-h-0 overflow-y-hidden overscroll-contain"
    (scroll)="closeMenuOnScroll()">
    <ul class="recent_chats">
      @for (c of state.conversations(); track c.id) {
        <li class="recent-chat-row">
          <a
            class="recent-chat-link"
            [routerLink]="['/ai-agent', c.id]"
            routerLinkActive="recent-chat-active"
            [routerLinkActiveOptions]="{ exact: true }">
            <span
              #titleEl
              class="recent-chat-title truncate pr-4"
              [pTooltip]="displayChatTitle(c.title)"
              [tooltipDisabled]="!isTitleClipped(titleEl)"
              tooltipPosition="right"
              tooltipStyleClass="conversation-title-tooltip">{{ displayChatTitle(c.title) }}</span>
            @if (hasSkill(c)) {
              <span class="skill-icon shrink-0" title="Started from a skill" aria-label="Skill chat">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                  <use xlink:href="assets/images/icon-library.svg#lightbulb"></use>
                </svg>
              </span>
            }
            <span class="rotate-45 shrink-0 pin-icon" [class.invisible]="!isPinned(c)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <use xlink:href="assets/images/icon-library.svg#pin"></use>
              </svg>
            </span>
          </a>
          <button
            type="button"
            class="chat-actions-btn"
            aria-label="Conversation actions"
            (click)="toggleMenu($event, c)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="3" r="1.2" fill="currentColor"></circle>
              <circle cx="8" cy="8" r="1.2" fill="currentColor"></circle>
              <circle cx="8" cy="13" r="1.2" fill="currentColor"></circle>
            </svg>
          </button>
        </li>
      }
    </ul>
  </div>

  @if (activeMenuConversation && menuStyle) {
    <div
      class="chat-actions-menu chat-actions-menu--fixed"
      [style.top.px]="menuStyle.top"
      [style.left.px]="menuStyle.left"
      (click)="$event.stopPropagation()">
      <!-- <button type="button" (click)="copyConversationLink($event, activeMenuConversation.id)">Copy link</button> -->
      <button type="button" (click)="togglePin($event, activeMenuConversation)">
        {{ isPinned(activeMenuConversation) ? 'Unpin' : 'Pin' }}
      </button>
      <button type="button" class="danger" (click)="deleteConversation($event, activeMenuConversation)">
        Delete
      </button>
    </div>
  }

  @if (state.conversationsHasMore()) {
    <button
      type="button"
      class="recent-chats-more w-full px-10 py-8 text-left text-[12px] font-medium text-[var(--p-primary-600)] hover:text-[var(--p-primary-700)] hover:bg-[var(--p-primary-50)] rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="state.conversationsLoadingMore()"
      (click)="loadMore()">
      {{ state.conversationsLoadingMore() ? 'Loading…' : 'Load more' }}
    </button>
  }
</div>
